/**Статус операции */
export enum ScheduleStates {
  /** Ожидается */
  Waiting = 0,
  /** Погашен */
  Success = 2,
  /** Просрочен */
  Failed = 3,
  /**Ошибка исполнения */
  Error = 4
}
